module.exports = __webpack_public_path__ + "img/avt.63eeb3f0.png";